import {Box, HStack, Text} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {SortType} from './TriArticlesCadencier';
import {ArrowUpDownIcon} from '@chakra-ui/icons';
import {useHalState} from '@synako/haligator';
import {useClient} from '@/haligator-factory';

interface TriSectionsCadencierProps {
  value: SortType;
  onChange: (value: SortType) => void;
}

// Composant pour sélectionner le type de tri des articles par fréquence d’achat (suggestions) ou ordre alphabétique
export const TriSectionsCadencier: React.FC<TriSectionsCadencierProps> = ({
  value,
  onChange,
}) => {
  const {t} = useTranslation();
  const client = useClient();
  const {state: suggestionsState} = useHalState(client.follow('suggestions'));

  const changement_tri_possible = !!suggestionsState?.data.suggestions.length;

  const handleToggle = () => {
    const newValue: SortType =
      value === 'alphabetic' ? 'frequency' : 'alphabetic';
    onChange(newValue);
  };

  value = !changement_tri_possible ? 'alphabetic' : value;

  return (
    changement_tri_possible && (
      <Box mr='10px'>
        <HStack
          bg='gray.75'
          border='2px solid'
          borderColor='gray.light'
          borderRadius='8px'
          h='38px'
          w='190px'
          px={2}
          alignItems='center'
          justifyContent='space-between'
          cursor='pointer'
          onClick={handleToggle}
        >
          <Text
            color='blue.text'
            fontWeight='700'
            fontSize='xs'
            whiteSpace='nowrap'
          >
            {t('cadencier.tri.tri')}
          </Text>
          <Text
            color='blue.text'
            fontWeight='500'
            fontSize='xs'
            whiteSpace='nowrap'
          >
            {value === 'alphabetic'
              ? t('cadencier.tri.alphabetique')
              : t('cadencier.tri.frequence')}
          </Text>
          <ArrowUpDownIcon
            color='blue.main'
            boxSize='18px'
          />
        </HStack>
      </Box>
    )
  );
};
